export const CHAT_TEMPLATE_SENT_MSG = 'Template sent';
